export const CTA_TEXT = `Take 100% control and work less`
export const CTA_TEXT_LAN = `Take 100% control and work less`
export const CTA_BTN_TEXT_LAN = 'Contact Us'
export const CTA_BTN_TEXT = 'Get Started'
export const CTA_PATH = '#paths.com'
